import React from 'react';

import Animated1ChipSVG from '../components/AnimatedChips/Animated1ChipSVG';
import Animated01ChipSVG from '../components/AnimatedChips/Animated01ChipSVG';
import Animated001ChipSVG from '../components/AnimatedChips/Animated001ChipSVG';
import Animated005ChipSVG from '../components/AnimatedChips/Animated005ChipSVG';

export const baccaratOptions = {
  P: {
    label: 'Player',
  },
  B: {
    label: 'Banker',
  },
  T: {
    label: 'Tie',
  },
  PP: {
    label: 'Player Pair',
  },
  BP: {
    label: 'Banker Pair',
  },
};
// eslint-disable-next-line import/no-mutable-exports
let chips = {
  1: <Animated1ChipSVG />,
  0.1: <Animated01ChipSVG />,
  0.01: <Animated001ChipSVG />,
  0.05: <Animated005ChipSVG />,
};
if (process.env.REDUCED_BETS === 'true') {
  const newChips = {};
  Object.entries(chips).forEach(([value, chip]) => {
    newChips[value / 100] = chip;
  });
  chips = newChips;
}

export { chips };
